<template>
  <div id="page-campaign-buy-subscription">
    <vs-alert color="danger" title="Campaign Not Found" v-if="entityNotFound">
      <span>
        Campaign record with id
        <strong>{{ $route.params.campaignId }}</strong> not found.
      </span>
      <span>
        <span>Check</span>
        <router-link
          :to="{ name: 'campaign-list' }"
          class="text-inherit underline"
          >{{ this.$t("Campaign.List") }}</router-link
        >
      </span>
    </vs-alert>
    <vs-alert color="danger" title="Strategy Not Found" v-if="strategyNotFound">
      <span>
        Strategy record with id
        <strong>{{ this.idStrategy }}</strong> not found.
      </span>
    </vs-alert>

    <div id="campaign-data" v-if="campaign && strategy">
      <vx-card :title="this.$t('Campaign.Title')" class="mb-base">
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>{{ this.$t("Campaign.Name") }}</span>
          </div>
          <div class="vx-col sm:w-5/6 w-full">
            {{ campaign.name }}
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>{{
              this.$t(`Strategy.Title${campaign.idStrategyType}`)
            }}</span>
          </div>
          <div class="vx-col sm:w-5/6 w-full">
            <span>{{ strategy.name }} {{ strategy.address2 }}}</span>
          </div>
        </div>
        <hr />
        <h4 class="mt-8">{{ $t("BuySubscription.SelectDateRange") }}</h4>
        <div class="vx-row">
          <div class="vx-col sm:w-5/6 w-full">
            <DxRangeSelector
              id="range-selector"
              :value.sync="range"
              :ref="dateRangeRefKey"
            >
              <DxMargin :top="20" />
              <DxScale :start-value="startValue" :end-value="endValue">
                <DxMinorTick :visible="false" />
                <DxMinorTickInterval :days="1" />
                <DxTickInterval :weeks="1" />
                <DxMinRange :weeks="1" />
                <DxMaxRange :days="200" />
              </DxScale>
              <DxSliderMarker format="monthAndDay" />
            </DxRangeSelector>
          </div>
          <div class="vx-col sm:w-1/6 w-full mt-10">
            <span style="float: left"
              ><vs-button
                radius
                icon="icon-minus"
                icon-pack="feather"
                @click="addDay(-1)"
            /></span>

            <span class="days">{{
              `${runTime} ${$t("BuySubscription.Days")}`
            }}</span>
            <span style="float: left">
              <vs-button
                radius
                icon="icon-plus"
                icon-pack="feather"
                @click="addDay(1)"
              />
            </span>
          </div>
        </div>
        <h4 class="mt-8">{{ $t("BuySubscription.DailyBudget") }}</h4>
        <h1 class="text-center daily-budget">{{ dailyBudget | currency }}</h1>
        <DxSlider :min="1" :max="200" :value.sync="dailyBudget" />
        <vs-alert v-if="dailyBudget < 3" active="true">
          {{ $t("BuySubscription.MinBudgetWarning") }}
        </vs-alert>
      </vx-card>
      <vx-card :title="$t('BuySubscription.OrderAndPay')">
        <div class="vx-row order-and-pay">
          <div class="vx-col w-1/3">
            <vs-button
              style="width: 100%"
              class="ml-auto mt-2"
              icon-pack="feather"
              icon="icon-arrow-up"
              v-show="enterVoucherLinkVisible"
              @click="exchangeVoucher"
              >{{ $t("BuySubscription.ExchangeVoucher") }}</vs-button
            >
            <vs-button
              style="width: 100%"
              class="ml-auto mt-2"
              icon-pack="feather"
              icon="icon-delete"
              v-show="voucherEntered"
              @click="removeVoucher"
              >{{ removeVoucherCaption }}</vs-button
            >
            <div v-show="enterVoucherVisible">
              <div class="dx-fieldset">
                <div class="dx-field">
                  <div class="dx-field-label">
                    {{ this.$t("BuySubscription.VoucherCode") }}
                  </div>
                  <div class="dx-field-value">
                    <DxTextBox :value.sync="voucherCode"> </DxTextBox>
                  </div>
                </div>
                <div class="dx-field">
                  <vs-button
                    style="width: 100%"
                    class="ml-auto mt-2"
                    icon-pack="feather"
                    icon="icon-plus"
                    @click="applyVoucher"
                    >{{ $t("BuySubscription.ApplyVoucher") }}</vs-button
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="vx-col w-1/3"></div>
          <div class="vx-col w-1/3">
            <div class="dx-fieldset">
              <div class="dx-field">
                <div class="dx-field-label">
                  {{ $t("BuySubscription.TotalBudget") }}
                </div>
                <div class="dx-field-value text-right">
                  {{ totalBudget | currency }}
                </div>
              </div>
              <div class="budget-explanation">
                {{
                  $t("BuySubscription.TotalBudgetExplanation", {
                    days: runTime,
                    euro: this.$options.filters.currency(this.dailyBudget),
                  })
                }}
              </div>
              <div class="dx-field" v-if="voucherEntered">
                <div class="dx-field-label">
                  {{ $t("BuySubscription.ReductionAmount") }}
                </div>
                <div class="dx-field-value text-right">
                  {{ reductionAmount | currency }}
                </div>
              </div>
              <div class="budget-explanation" v-if="voucherEntered">
                {{ reductionExplanation }}
              </div>

              <div class="dx-field">
                <div class="dx-field-label">
                  {{ $t("BuySubscription.TotalVat") }}
                </div>
                <div class="dx-field-value text-right">
                  {{ totalVat | currency }}
                </div>
              </div>
              <hr class="mb-5"/>
              <div class="dx-field">
                <div class="dx-field-label">
                  {{ $t("BuySubscription.PaymentTotal") }}
                </div>
                <div class="dx-field-value text-right">
                  {{ paymentTotal | currency }}
                </div>
              </div>

            </div>
            <hr class="my-3" />
            <div class="row mb-3" v-show="paymentTotal">
              <ul class="leftx">
                <li class="mb-2">
                  <vs-radio
                    color="primary"
                    v-model="paymentMethod"
                    vs-value="ideal"
                    ><img
                      class="mr-1"
                      width="40"
                      src="@/assets/images/payment-methods/ideal.png"
                    />
                    iDeal</vs-radio
                  >
                </li>
                <li class="mb-2">
                  <vs-radio
                    color="primary"
                    v-model="paymentMethod"
                    vs-value="bancontact"
                    ><img
                      class="mr-1"
                      width="40"
                      src="@/assets/images/payment-methods/bancontact.png"
                    />
                    Bancontact</vs-radio
                  >
                </li>
              </ul>
            </div>
            <vs-button
              style="width: 100%"
              class="ml-auto mt-2"
              @click="buySubscription"
              >{{ $t("BuySubscription.Buy") }}</vs-button
            >
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import moduleCampaignManagement from '@/store/campaign-management/moduleCampaignManagement.js'
import moduleStrategyManagement from '@/store/strategy-management/moduleStrategyManagement.js'
import moduleSubscriptionManagement from '@/store/subscription-management/moduleSubscriptionManagement.js'
import { DxTextBox } from 'devextreme-vue/text-box'
import { notifyMixin } from '@/mixins/notifyMixin'
import {
  DxRangeSelector,
  DxMargin,
  DxScale,
  DxMinorTick,
  DxMinorTickInterval,
  DxTickInterval,
  DxMinRange,
  DxMaxRange,
  DxSliderMarker
} from 'devextreme-vue/range-selector'
import { DxSlider } from 'devextreme-vue/slider'
import moment from "moment"
const startDate = moment().add(1, 'days')
const endDate = moment().add(15, "days")
const dateRangeRefKey = "date-range"
export default {
  data () {
    return {
      campaign: null,
      entityNotFound: false,
      strategyNotFound: false,
      idStrategy: 0,
      strategy: null,
      startValue: moment().add(1, 'days').toDate(),
      endValue: moment().add(-1, 'days').add(200, 'days').toDate(),
      range: [startDate.toDate(), endDate.toDate()],
      enterVoucherVisible: false,
      voucherEntered: false,
      voucherCode: "",
      voucherId: null,
      voucherValue: 0,
      enterVoucherLinkVisible: true,
      voucherMinimumSpentAmount: 0,
      paymentMethod: "ideal",
      startDate,
      endDate,
      dailyBudget: 7,
      vatPerc: 0.21,
      tooltip: {
        enabled: true,
        showMode: 'always',
        position: 'top',
      },
      dateRangeRefKey
    }
  },
  mixins: [notifyMixin],
  components: {
    DxRangeSelector,
    DxMargin,
    DxScale,
    DxMinorTick,
    DxMinorTickInterval,
    DxTickInterval,
    DxMinRange,
    DxMaxRange,
    DxSliderMarker,
    DxSlider,
    DxTextBox
  },
  methods: {
    fetchStrategy () {
      this.$store.dispatch("strategyManagement/fetchStrategy", this.idStrategy)
        .then((res) => {
          this.strategy = res.data.strategy
        }).catch(err => {
          if (err.response.status === 404) {
            this.strategyNotFound = true
            return
          }
          this.notifyError(err)
        })
    },
    applyVoucher () {
      this.$store.dispatch('campaignManagement/fetchVoucher', { idStrategy: this.idStrategy, code: this.voucherCode })
        .then(res => {
          const voucher = res.data.voucher
          this.voucherId = voucher.id
          this.voucherCode = voucher.code
          this.voucherValue = voucher.value
          this.voucherMinimumSpentAmount = voucher.minimumSpentAmount
          this.voucherEntered = true
          this.enterVoucherVisible = false
          this.enterVoucherLinkVisible = false
        })
        .catch(err => {
          this.notifyError(err, "BuySubscription")
        })
    },
    exchangeVoucher () {
      this.enterVoucherLinkVisible = false
      this.enterVoucherVisible = true
      this.voucherEntered = false
    },
    removeVoucher () {
      this.voucherCode = ""
      this.voucherValue = 0
      this.voucherMinimumSpentAmount = 0
      this.voucherId = 0
      this.enterVoucherLinkVisible = true
      this.voucherEntered = false
    },
    buySubscription () {
      console.log('Start buying')
      const payload = {
        idCampaign: this.campaign.id,
        idStrategy: this.idStrategy,
        idCustomer: this.$store.state.AppActiveUser.uid,
        vatPercentage: this.vatPerc,
        amountVat: this.totalVat,
        voucherCode: this.voucherCode,
        lines: [{
          IdProduct: 1,
          Description: "Daily budget bulk",
          PricePerUnit: this.dailyBudget,
          Quantity: this.runTime,
          StartDate: this.startDate
        }]
      }
      this.$vs.loading()
      this.$store
        .dispatch(
          'subscriptionManagement/buy',
          payload
        )
        .then((response) => {
          const order = response.data.order
          if (order.state == "Paid") {
            this.$vs.loading.close()
            this.notifySuccess('BuySubscription.OrderHasBeenPlacedAndPaid')
            this.$router.push("orders").catch(() => { })
            return
          }

          const urlParts = window.location.href.split("/")
          const payment = {
            id: order.id,
            paymentOption: this.paymentMethod,
            paymentFinishUrl: `${urlParts[0]}//${urlParts[2]}/campaign/${this.campaign.id}/paymentfinished`
          }
          this.$store.dispatch("subscriptionManagement/startPayment", payment)
            .then(response => {
              window.location = response.data.paymentUrl
              this.$vs.loading.close()
            }).catch(error => {
              this.$vs.loading.close()
              this.notifyError(error)
            })
        })
        .catch((error) => {
          this.$vs.loading.close()
          this.notifyError(error)
        })
    },
    addDay (day) {
      if (day == 1 && this.range[1] >= this.endValue) {
        return
      }

      if (this.runTime >= 200 && day == 1) {
        return
      }
      if (this.runTime <= 7 && day == -1) {
        return
      }
      const rs = this.$refs[this.dateRangeRefKey].instance
      const newEndDate = moment(this.range[1]).add(day, 'day')
      const newRange = [this.range[0], newEndDate.toDate()]
      rs.option('value', newRange)
      rs.repaint()
    },
  },
  created () {
    const x = this.$route.query.idStrategy
    if (x) {
      this.idStrategy = Math.trunc(x)
    }
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule('campaignManagement', moduleCampaignManagement)
      moduleCampaignManagement.isRegistered = true
    }
    if (!moduleStrategyManagement.isRegistered) {
      this.$store.registerModule(
        'strategyManagement',
        moduleStrategyManagement
      )
      moduleStrategyManagement.isRegistered = true
    }
    if (!moduleSubscriptionManagement.isRegistered) {
      this.$store.registerModule(
        'subscriptionManagement',
        moduleSubscriptionManagement
      )
      moduleSubscriptionManagement.isRegistered = true
    }
    const campaignId = this.$route.params.campaignId
    this.$store.dispatch('campaignManagement/fetchCampaign', campaignId)
      .then(res => {
        this.campaign = res.data.campaign
        if (this.campaign === null) {
          this.entityNotFound = true
          return
        }
        if (this.campaign.idStrategyType > 1 && this.idStrategy) {
          this.fetchStrategy(this.idStrategy)
        } else {
          this.strategyNotFound = true
        }
        if (this.campaign.startDate) {
          const startDate = moment(this.campaign.startDate).toDate()
          if (startDate > this.startValue) {
            this.startValue = startDate
          }
        }
        if (this.campaign.endDate) {
          const endDate = moment(this.campaign.endDate).toDate()
          if (endDate < this.endValue) {
            this.endValue = endDate
          }
        }
      })
      .catch(err => {
        if (err.response.status === 404) {
          this.entityNotFound = true
          return
        }
        this.notifyError(err)
      })
  },
  computed: {
    runTime () {
      return moment(this.range[1]).diff(moment(this.range[0]), 'days')
    },
    totalBudget () {
      return this.dailyBudget * this.runTime
    },
    reductionAmount () {
      if (!this.voucherId) {
        return 0
      }
      if (this.totalBudget < this.voucherMinimumSpentAmount) {
        return 0
      }
      if (this.voucherValue > this.totalBudget) {
        return -this.totalBudget
      }
      return -this.voucherValue
    },
    reductionExplanation () {
      return this.voucherMinimumSpentAmount == 0 
      ? this.$t("BuySubscription.ReductionExplanation1", {voucherValue: this.voucherValue})
      : this.$t("BuySubscription.ReductionExplanation2", {voucherValue: this.voucherValue, voucherMinimumSpentAmount: this.voucherMinimumSpentAmount})
    },
    totalVat () {
      return (this.totalBudget + this.reductionAmount) * this.vatPerc
    },
    paymentTotal () {
      return this.totalBudget + this.reductionAmount + this.totalVat
    },
    reductionVisible () {
      return this.voucherId
    },
    removeVoucherCaption () {
      return this.$t('BuySubscription.RemoveVoucherCode', { code: this.voucherCode })
    }
  },
}

</script>

<style lang="scss">
#page-campaign-buy-subscription {
  .dx-field-label {
    font-size: 1eem;
    font-weight: bolder;
  }
  .dx-field-value {
    font-size: 1.2rem;
    font-weight: bolder;
  }

  .total {
    font-weight: bold;
  }
  table {
    td {
      vertical-align: top;
      min-width: 250px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }
  }

  .budget-explanation {
    font-size: 0.9rem;
    margin-top: -20px;
    margin-bottom: 20px;
  }

  .daily-budget {
    color: #00adbb !important;
  }
  .days {
    float: left;
    line-height: 38px;
    vertical-align: middle;
    margin-right: 4px;
    margin-left: 4px;
  }
}
</style>
